import React from "react";
import { Container } from "react-bootstrap";
import { LanguageEditorArea } from "./languageEditorArea";
import "../../assets/css/components/newLanguageEditor.css"

export function NewLanguageEditor(){

  return(
    <Container style={{width:'100%', maxWidth:'100%'}}>
      <LanguageEditorArea />
    </Container>
  )
}
